module.exports = __webpack_public_path__ + "assets/images/custom-cues-330b8982d00a892ded40eaa1e6a252a4.png";